import * as React from "react";
import { LayoutDashboard, Fingerprint, Image as ImageIcon, Share2, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
const solutions = [{
  title: "Personal Care",
  description: "Dignified assistance with daily routines, including bathing, dressing, and medication management in your own home.",
  icon: LayoutDashboard,
  link: "/ServicesPage"
}, {
  title: "Companionship Care",
  description: "Meaningful social interaction and emotional support to enhance well-being and reduce feelings of isolation.",
  icon: Fingerprint,
  link: "/ServicesPage"
}, {
  title: "Live-in Care",
  description: "Round-the-clock professional support providing peace of mind and continuous care tailored to your specific needs.",
  icon: ImageIcon,
  link: "/ServicesPage"
}, {
  title: "Respite Care",
  description: "Temporary relief for primary caregivers, ensuring your loved one receives high-quality care while you recharge.",
  icon: Share2,
  link: "/ServicesPage"
}];
export default function OurSignatureSolutions() {
  return <section data-section-id="223689" id="tailored-care-solutions" className="bg-background text-foreground py-16 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 md:mb-24">
          <h2 className="font-default text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl text-primary">
            Tailored Care Solutions
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          {solutions.map((solution, i) => <Card key={i} data-index={i} className="group relative flex min-h-[320px] flex-col rounded-lg border-t-2 border-border bg-white p-0 pt-8 shadow-md transition-all duration-500 hover:shadow-xl hover:-translate-y-2 hover:border-t-4 hover:border-ring">
              <div className="px-6 pb-6 md:px-8 md:pb-8 flex flex-col h-full">
                <solution.icon className="size-8 text-ring transition-transform duration-500 group-hover:rotate-[15deg]" strokeWidth={1.5} />
                
                <h3 className="font-default mt-12 mb-4 text-xl font-bold leading-tight tracking-tight text-foreground">
                  {solution.title}
                </h3>
                
                <p className="font-sans text-muted-foreground text-base leading-relaxed">
                  {solution.description}
                </p>

                <div className="mt-auto pt-8 overflow-hidden">
                  <Link to={solution.link} className="inline-flex items-center gap-2 text-sm font-semibold text-ring opacity-0 -translate-x-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-1">
                    Learn More <ArrowRight className="size-4" />
                  </Link>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}